import styled, { css } from 'styled-components';
import { rem } from '../../utils';
const iconSize = css `
  ${({ theme }) => `
    height: ${rem(theme.Icon.Size.Large)};
    width: ${rem(theme.Icon.Size.Large)};
  `}
`;
export const StyledWrapper = styled.a `
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${iconSize}
`;
export const StyledImage = styled.span `
  ${iconSize}
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: ${({ sourceUrl }) => `url(${sourceUrl})`};
  border-radius: 50%;
`;
//# sourceMappingURL=ProfilePicture.style.js.map